import { emptyQuestion, type DraftQuestion, type SurveyForEdit } from './api';

/** טיוטת סקר, כפי שהטופס מחזיק אותה לפני השמירה. */
export type SurveyDraft = {
  title: string;
  description: string;
  analysis_note: string;
  is_anonymous: boolean;
  starts_at: string;
  ends_at: string;
  questions: DraftQuestion[];
};

export function emptyDraft(): SurveyDraft {
  return {
    title: '',
    description: '',
    analysis_note: '',
    // אנונימי כברירת מחדל: סקר על כלי שההנהלה כפתה מקבל תשובות
    // אמיתיות רק כשאין עליו שם
    is_anonymous: true,
    starts_at: '',
    ends_at: '',
    questions: [emptyQuestion()],
  };
}

/**
 * סקר שנטען מהשרת, כטיוטה שהטופס יודע להחזיק.
 *
 * התאריכים הופכים לפורמט של datetime-local, שהוא זמן מקומי בלי
 * אזור. new Date().toISOString() היה מחזיר UTC ומזיז את השעה.
 */
export function draftFromSurvey(survey: SurveyForEdit): SurveyDraft {
  return {
    title: survey.title,
    description: survey.description ?? '',
    analysis_note: survey.analysis_note ?? '',
    is_anonymous: survey.is_anonymous,
    starts_at: toLocalInput(survey.starts_at),
    ends_at: survey.ends_at ? toLocalInput(survey.ends_at) : '',
    questions: survey.questions.map((question) => ({
      key: question.id,
      id: question.id,
      prompt: question.prompt,
      answer_kind: question.answer_kind,
      options: question.options,
      section: question.section ?? '',
      analysis_note: question.analysis_note ?? '',
      is_required: question.is_required,
      allow_na: question.allow_na,
    })),
  };
}

function toLocalInput(iso: string): string {
  const date = new Date(iso);
  const pad = (value: number) => String(value).padStart(2, '0');
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
}
